<template>
    <div class="container">
            <div class="seach-container">
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">关键字</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-input
                                v-model="query.keyword"
                                size="small"
                                placeholder="请输入关键字"
                            ></el-input>
                            </div>
                        </div>
                    </div> 
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">状态</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.type" size="small" placeholder="请选择">
                                  <el-option label="线下" value="1"></el-option>
                                  <el-option label="线上" value="2"></el-option>
                                  <el-option label="全部" value=""></el-option>
                            </el-select>
                            </div>
                        </div>
                      </div>
                     <div class="form-container">
                        <div class="form-box-item serch-operate" >
                               <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">搜索</el-button>
                               <el-button  icon="el-icon-delete" size="mini" @click="handleEmpty">清空</el-button>
                        </div>
                    </div>
            </div>
            <div class="addBtn">
                 <!-- <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>  -->
            </div>
           <el-table
                :data="tableData"
                border
                :max-height="scrollHeight"
            >
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
                                 <!-- <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleUpdate(scope.$index, scope.row)">修改</el-button> -->
                                <el-button
                                size="mini"
                                type="info"
                                icon="el-icon-edit"
                                @click="handleUpdate(scope.$index, scope.row)">详情</el-button>
                                 <el-button
                                 icon="el-icon-delete"
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </div>
                            <div v-else-if="(scope.column.property==='Type')">
                               <span v-if="scope.row.Type==2">线上</span>
                               <span v-else>线下</span>
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
          <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
             <!-- 详情弹出框 -->
        <el-dialog :title="type=='add'?'新增积分' : '修改积分'" v-model="detailVisible" width="55%" top="6vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="110px">
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="姓名：">
                             <el-input
                                v-model="dataDetail.UserName"
                                size="small"
                                placeholder="请输入名称"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row>
                    <el-col :span="11">
                        <el-form-item label="积分负责人：">
                            <el-select v-model="dataDetail.UserID" size="small" placeholder="请选择"
                            @change="selectUser">
                                    <el-option label="请选择" value=""></el-option>
                                    <el-option :label="user.UserName" :value="user.UserID" :key="user.UserID" v-for="user in userList"></el-option>
                                </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="11">
                        <el-form-item label="负责人电话：">
                               <el-input
                                v-model="tel"
                                size="small"
                                :disabled="true"
                                placeholder="暂无"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row> -->
            </el-form>
                <div class="dialog-Btn">
                    <el-button size="small" @click="detailVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="addOrUpdateScore()">提交</el-button>
                </div>
        </el-dialog>
        <ScoreModel ref="ScoreModel"></ScoreModel>

    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
.dialog-Btn{
    text-align: center;
}
</style>